import React from 'react';
import SVG from '@newrelic/gatsby-theme-newrelic/src/components/SVG';

const UnityIcon = (props) => {
  return (
    <SVG {...props} viewBox="0 0 128 128">
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="m63.991 128 51.702-29.855-19.817-11.461-20.26 11.704a1.151 1.151 0 0 1-1.125-.009 1.145 1.145 0 0 1-.568-.975V69.608c0-.819.424-1.56 1.133-1.968L99.13 53.737a1.119 1.119 0 0 1 1.124.009c.352.195.572.564.576.966V78.11l19.83 11.454V29.855L63.99 62.566Zm0 0"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        fill="#4d4d4d"
        d="m52.397 98.401-20.27-11.718-19.832 11.46L63.991 128V62.566L7.34 29.854V89.56l19.825-11.45V54.714c.009-.401.225-.77.572-.966a1.13 1.13 0 0 1 1.13-.009L52.953 67.64a2.275 2.275 0 0 1 1.133 1.97v27.8a1.156 1.156 0 0 1-.565.98 1.131 1.131 0 0 1-1.124.012"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        fill="gray"
        d="M68.959 0v22.9L89.22 34.597c.348.203.555.576.555.984 0 .403-.212.772-.555.975L65.137 50.468a2.302 2.302 0 0 1-2.27 0L38.791 36.556a1.122 1.122 0 0 1-.56-.975 1.127 1.127 0 0 1 .56-.984L59.048 22.9V0L7.339 29.855l56.652 32.711 56.665-32.71Zm0 0"
      />
    </SVG>
  );
};

export default UnityIcon;
